import type { ReactNode } from 'react';

import type { FundingType } from '@openclassrooms/sdk-web';
import Button, { Props as ClassifyButtonProps } from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';

import { APPSOURCE_NAMES } from '../../constants/appSourcesConfig';
import { getAdmissionFunnelLinkProps } from '../../services/getAdmissionFunnelUrl';

interface ApplyButtonProps extends ClassifyButtonProps {
  pathId?: number;
  children?: ReactNode;
  'data-event'?: string;
  fundingType?: FundingType;
}

export default function ApplyButton({
  children = translate('global.apply.cta'),
  'data-event': dataEvents = 'Navigation|Redirection::Internal|Apply',
  pathId,
  fundingType,
  ...props
}: ApplyButtonProps): JSX.Element {
  const linkProps = getAdmissionFunnelLinkProps(APPSOURCE_NAMES.GENERIC, pathId, fundingType);

  return (
    <Button
      data-event={dataEvents}
      {...linkProps}
      {...props}
      data-testid="genericApplyButton"
      rel="nofollow"
    >
      {children}
    </Button>
  );
}
